import { ref } from 'vue';
import SpeciesIcon from '/SPECIES.svg?raw';
import FeaturesIcon from '/FEATURES.svg?raw';
import PeopleIcon from '/PEOPLE.svg?raw';
import CoastalIcon from '/COASTAL.svg?raw';
import SelectAreaIcon from '/SELECT_AREA.svg?raw';
import SpSelectIcon from '/SELECTSPECIES.svg?raw';
import SpSelectV2Icon from '/SELECTSPECIESv2.svg?raw';
import SpeciesV2Icon from '/SPECIESv2.svg?raw';
import FeaturesV2Icon from '/FEATURESv2.svg?raw';
import PeopleV2Icon from '/PEOPLEv2.svg?raw';
import CoastalV2Icon from '/COASTALv2.svg?raw';

const myIcons = {
  species: SpeciesIcon,
  features: FeaturesIcon,
  people: PeopleIcon,
  coastal: CoastalIcon,
  selectArea: SelectAreaIcon,
  spSelect: SpSelectIcon,
  spSelectV2: SpSelectV2Icon,
  speciesV2: SpeciesV2Icon,
  featuresV2: FeaturesV2Icon,
  peopleV2: PeopleV2Icon,
  coastalV2: CoastalV2Icon,
};

export function useSvgIcon() {
  const getIcon = (iconName) => {
    return myIcons[iconName];
  };

  return {
    getIcon,
  };
}